import smalllogo from 'assets/app_logo.png';

export const TableLoader = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center', // vertical center
        alignItems: 'center',     // horizontal center
        height: '100%',           // take full available space
        minHeight: '200px',       // ensure visible center even with small tables
      }}
    >
      <img src={smalllogo} alt="Loading..." style={{ width: 150, marginBottom: 16 }} />
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200' width="80" height="40">
        <circle fill='#D1712A' stroke='#D1712A' strokeWidth='15' r='15' cx='40' cy='100'>
          <animate attributeName='opacity' calcMode='spline' dur='2s' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.4s'></animate>
        </circle>
        <circle fill='#D1712A' stroke='#D1712A' strokeWidth='15' r='15' cx='100' cy='100'>
          <animate attributeName='opacity' calcMode='spline' dur='2s' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.2s'></animate>
        </circle>
        <circle fill='#D1712A' stroke='#D1712A' strokeWidth='15' r='15' cx='160' cy='100'>
          <animate attributeName='opacity' calcMode='spline' dur='2s' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='0s'></animate>
        </circle>
      </svg>
    </div>
  );
};
